import { getFirst } from '#imports'

// Nome del parametro query con cui lo store locator riceve il negozio da
// evidenziare. Volutamente diverso da `place` (ricerca per luogo) e da
// `appuntamento` (scheda rivenditore).
export const HIGHLIGHT_STORE_QUERY_PARAM = 'store'

/**
 * Route dello store locator che mostra un negozio dentro i risultati: la
 * provincia per gli store italiani, il paese per quelli esteri.
 *
 * Serve ai negozi senza scheda dettaglio (`detailsPageEnabled` a false, oggi
 * il 41% degli store sul sito it e la quasi totalita' sugli altri): invece di
 * mandarli sulla landing generica del locator, si atterra sulla lista del loro
 * territorio con la card evidenziata.
 *
 * Il nome della rotta va passato a `localePath()` prima dell'uso: con
 * `strategy: 'prefix'` i nomi reali sono suffissati (`...___it`).
 *
 * @returns {{name: string, params: object, query: object}|null} null quando i
 *   dati territoriali non bastano: il chiamante ripiega su `store-locator`.
 */
export const getStoreLocatorTarget = store => {
  if (!store?.id) return null

  const query = { [HIGHLIGHT_STORE_QUERY_PARAM]: String(store.id) }

  const country = getFirst(store.foreignCountry)
  if (country?.slug && country?.parent?.slug) {
    return {
      name: 'store-locator-abroad-continent-country',
      params: {
        continent: country.parent.slug,
        country: country.slug
      },
      query
    }
  }

  const province = getFirst(store.province)
  if (province?.slug && province?.parent?.slug) {
    return {
      name: 'store-locator-italy-region-province',
      params: {
        region: province.parent.slug,
        province: province.slug
      },
      query
    }
  }

  return null
}

/**
 * Riduce i risultati del locator al solo negozio cercato.
 *
 * Chi arriva con `?store=<id>` ha cercato quel negozio per nome, non un
 * territorio: la lista intera della provincia (o del paese) e' rumore, quindi
 * si mostra solo la sua card. La lista completa resta a un clic, il form in
 * cima alla pagina e' gia' compilato con la provincia o il paese giusto.
 *
 * La distanza viene tolta con il resto della lista: il "a X km da <luogo>"
 * descriveva l'ordinamento per prossimita', qui non c'e' piu' un confronto.
 *
 * Fail open: se l'id non e' tra i risultati (id inventato nell'URL, negozio
 * spostato di provincia nel CMS) si mostra la lista completa, come prima.
 */
export const filterHighlightedStore = (stores, highlightStoreId) => {
  if (!Array.isArray(stores) || !stores.length) return stores ?? []
  if (!highlightStoreId) return stores

  const match = stores.find(s => String(s?.id) === String(highlightStoreId))
  if (!match) return stores

  const single = { ...match }
  delete single.distance

  return [ single ]
}
